import { LoadReportParams } from "@enfusion-ui/types";
import {
  ReportContextDataStoreEntry as ReportContextDataStoreEntryBase,
  ReportContextMetaStoreEntry,
  ReportContextRowsStoreEntry,
  ReportDataChangeHandler,
} from "@enfusion-ui/web-core";
import { noop } from "lodash";
import * as React from "react";

import { SocketData } from "../../types/socket";

export type ReportContextDataStoreEntry = ReportContextDataStoreEntryBase &
  ReportContextRowsStoreEntry;

export type ReportsProviderReducerState = {
  changeSubscriptions: Record<string, Array<ReportDataChangeHandler>>;
  openSubscriptions: Record<string, string>;
  metaStore: Record<string, ReportContextMetaStoreEntry>;
  dataStore: Record<string, ReportContextDataStoreEntry>;
};
export type ReportHandleSyncParams = {
  reportId: string;
  message: string;
};

export type ReportOpenDetailTableArgs = {
  destination: string;
  parentTableId: string;
  row: string;
  tableId?: string | undefined;
};

export type ReportsContextType = Omit<
  ReportsProviderReducerState,
  "changeSubscriptions" | "openSubscriptions"
> & {
  reportId: string;
  loadReport: (params: LoadReportParams) => void;
  closeReport: (reportId: string, tableId: string) => void;
  subscribeToReportChange: (
    tableId: string,
    callback: ReportDataChangeHandler
  ) => VoidFunction;
  initializeReports: (secureToken?: string) => void;
  openDetailTable: ({
    destination,
    parentTableId,
    row,
    tableId,
  }: ReportOpenDetailTableArgs) => void;
  messages: SocketData[];
};

export const ReportsContext = React.createContext<
  ReportsContextType | undefined
>(undefined);

export function useReports() {
  const context = React.useContext(ReportsContext);
  if (context === undefined) {
    return { openReportTab: noop } as unknown as ReportsContextType;
  }
  return context;
}
